const store = {
  // default state
  state: {
    sitecoreContext: {
      pageEditing: false,
    },
    routeData: null,
  },
  setSitecoreData(sitecoreData) {
    const route = sitecoreData.sitecore && sitecoreData.sitecore.route;
    const context = (sitecoreData.sitecore && sitecoreData.sitecore.context) || {};
    // SSR 时 proxy-ssr 通过 viewBag.context 注入真实请求 host（x-forwarded-host / Host），
    // 合并进 sitecoreContext 供 og:url / canonical 等绝对 URL 使用；客户端导航无 viewBag，此处为空对象
    const viewBagContext = (sitecoreData.viewBag && sitecoreData.viewBag.context) || {};

    // Do not replace the original state object - the store and any components that use the store
    // need to share a reference to the same object in order for mutations to be observed.
    this.state.routeData = route;
    this.state.sitecoreContext = {
      ...context,
      ...viewBagContext,
      routeName: route && route.name,
      itemId: route && route.itemId,
    };
  },
};

export { store };

// Vue plugins must export a function named 'install'
function install(App) {
  App.config.globalProperties.$jss = {
    // there may be other JSS plugins installed, merge existing properties
    ...(App.config.globalProperties.$jss || {}),
    store,
    sitecoreContext() {
      // this is intended only as a convenience function for easier access to the current context.
      return store.state.sitecoreContext;
    },
    routeData() {
      // this is intended only as a convenience function for easier access to the current routeData.
      return store.state.routeData;
    },
  };
}

export default { install };
